// extracted by mini-css-extract-plugin
module.exports = {"container":"AccountCreating_container_3fvuq","header":"AccountCreating_header_1xAII","form":"AccountCreating_form_Bxups"};